import { Component, OnInit, ViewChild } from '@angular/core';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-notifiche-immissione-manuale',
  templateUrl: './notifiche-immissione-manuale.component.html',
  styleUrls: ['./notifiche-immissione-manuale.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificheImmissioneManualeComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('searchInput') searchInput;
	@ViewChild('immissioneNotificheForm') immissioneNotificheForm;
	@ViewChild('notificaAdd') notificaAdd;

	searchId: number;
	findComplete = true;
	modalInput: any = {
		data: {
			uid: null,
			id_prat: null,
			dataNotifica: null,
			indiceNotifica: null,
			tipoNotifica: null,
		}
	};

	tipiNotificaSync: Subscription;
	tipiNotifica: any[] = [];
	datiPratica: any = null;
	datiAnagrafica: any = null;
	datiAtto: any = null;

	constructor(private cdr: ChangeDetectorRef, protected dataService: DataService) {
		super(dataService, 'notifiche-immissione-manuale');
	}

	ngOnInit() {
		this.reset();
		this.tipiNotificaSync = this.dataService.tipiNotifica$.subscribe(
			tipiNotifica => {
				this.tipiNotifica = tipiNotifica;
			});
	}

	getPratica() {
		console.log("get prat", this.searchId, !this.datiPratica,  !this.datiAnagrafica);
		this.findComplete = false;
		this.dataService.getPraticaByIdPrat(this.searchId, (pratica) => {
			this.datiPratica = pratica;
			if (this.datiPratica) {
				console.log('PRATICA:', this.searchId, this.datiPratica);
				this.getAnagrafica();
				this.getAtto();
				this.modalInput = {
					data: {
						uid: this.datiPratica.id,
						id_prat: this.searchId,
					}
				};
				if (this.datiAtto) {
					this.modalInput['dataNotifica'] = this.datiAtto.notifica_data;
					this.modalInput['indiceNotifica'] = this.datiAtto.notifica_indice;
					this.modalInput['tipoNotifica'] = this.datiAtto.notifica_tipo;
				}
				else {
					this.modalInput['dataNotifica'] = null;
					this.modalInput['indiceNotifica'] = null;
					this.modalInput['tipoNotifica'] = null;
				}
			}
			this.findComplete = true;
		});
	}

	getAnagrafica() {
		this.dataService.getPersonById(this.datiPratica.anagrafica_id, (person) => {
			console.log("notifiche person", person);
			this.datiAnagrafica = person;
		});
		console.log('ANAGRAFICA:', this.datiAnagrafica);
	}

	getAtto() {
		this.dataService.getAttiByUid(this.datiPratica.id, (atti) => {
			if (atti.length) {
				this.datiAtto = atti[0];
			}
			else {
				this.datiAtto = null;
			}
			console.log('ATTO:', this.datiAtto);
		});
	}

	ngAfterViewInit() {
		if ( this.checkPermission('notifiche-immissione-manuale','read') ) {
			this.reset();
			this.immissioneNotificheForm.valueChanges
				.subscribe(data => { this.getPratica(); });
		}
	}

	getNomeNotifica(id: string) {
		let nome : string = '';
		for (let notifica of this.tipiNotifica) {
			if (notifica.id == id) {
				return notifica.descrizione;
			}
		}
		return nome;
	}

	reset() {
		this.searchId = null;
		this.datiPratica = null;
		this.datiAnagrafica = null;
		this.datiAtto = null;
		this.findComplete = true;
		if(this.notificaAdd){
			this.notificaAdd.reset();
		}
		this.cdr.markForCheck();
		//this.searchInput.nativeElement.focus();
	}

	getInnerEvents(event: any) {
		let localComuneId = true;
		let localFilters: any = [];
		let localSets: any = {};
		console.log(event);
		if(event.aggiungiNotifica){
			localSets = event.setValue;
			this.dataService.updateNotifica(event.uid, localFilters, localSets, localComuneId, (error,res) => {
				if (error) {
					console.log('updateNotifica|error',error);
				}
				else {
					console.log('updateNotifica|success',res);
					this.getAtto();
				}
			});
		}
	}

	ngOnDestroy() {
		console.log("tipiNotificaSync", this.tipiNotificaSync);
		this.tipiNotificaSync.unsubscribe();
	}
}
